import { ValidatorFn, AbstractControl } from '@angular/forms';


export function correctRutValidator(): ValidatorFn {

  return (control: AbstractControl): {[key: string]: any} => {
    if (control.value === '' || control.value === null || control.value === undefined) {
      return null;
    }
    let _rut = ''
    if(control.value && typeof control.value === 'object' && control.value.hasOwnProperty('values') ){
      _rut = control.value.values;
    } else {
      _rut = (control.value).replace(/[\.-]+/g, '');
    }
    let t = parseInt(_rut.slice(0, -1 ), 10), m = 0, s = 1;
    while (t > 0) {
      s = (s + t % 10 * (9 - m++ % 6)) % 11;
      t = Math.floor(t / 10);
    }
    const v = (s > 0) ? (s - 1) + '' : 'K';
    if (v !== _rut.slice(-1).toUpperCase()) {
      return {
        'correctRut': true
      };
    }
    return null;
  };
}
